import React, { useRef, useState } from "react"
import { Card } from "frontend/components/layout"
import { Button } from "frontend/components/interaction"
import { Heading } from "frontend/components/text"
import t from "frontend/utils/translations"
import CloudUpload from "./CloudUpload"
import LocalUpload from "./LocalUpload"
import styles from "./FilePicker.module.css"

const FilePicker = ({ onFileSelection }) => {
  const dropzoneRef = useRef(null)
  const [error, setError] = useState("")

  const handleClick = () => {
    setError("")
    dropzoneRef.current.click()
  }

  return (
    <Card className={styles.container}>
      <div className={styles.localUpload}>
        {error && (
          <div className={styles.error}>
            <p>Try Again</p>
            <Heading size={3}>{error}</Heading>
          </div>
        )}
        <Button
          label={t("upload.selection.prompt")}
          onClick={handleClick}
          icon="upload"
          className={styles.uploadButton}
        />
        <p className={styles.dragCta}>{t("upload.selection.prompt_drag")}</p>
      </div>
      <hr className={styles.hr} />
      <CloudUpload onFileSelection={onFileSelection} setError={setError} />
      <LocalUpload inputRef={dropzoneRef} onFileSelection={onFileSelection} setError={setError} />
    </Card>
  )
}

FilePicker.defaultProps = {
  onFileSelection: () => {},
}

export default FilePicker
